export default ({ brandName, abbrNameForTealium }) => {
  return brandName === 'gapfs' ? abbrNameForTealium : brandName;
};
